import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { COOKIE_NAMES, STORE_NAME } from '@intigral/constant';
import { get, isCSRFTokenValid, setCSRFToken } from '@intigral/utils/lib/browser-storage/localStorage';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { getCookie } from '@intigral/utils';

export interface IFormSignatureObjectUseCase {
    execute(): Promise<{ [key: string]: string } | null>;
}

export class FormSignatureObjectUseCase implements IFormSignatureObjectUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(): Promise<{ [key: string]: string } | null> {
        const storeToken = get(STORE_NAME.API_TOKEN);
        const csrfToken = getCookie(COOKIE_NAMES.API_TOKEN);
        // if (
        //     storeToken &&
        //     storeToken.data.tokenName &&
        //     storeToken.expires &&
        //     storeToken.data &&
        //     storeToken.expires > Date.now()
        //     && csrfToken === storeToken?.data?.token
        // ) {
        //     return { [storeToken.data.tokenName]: storeToken.data.token };
        // }
        if (isCSRFTokenValid(storeToken, csrfToken)) {
            return { [storeToken.data.tokenName]: storeToken.data.token };
        }
        const response = await this.authRepo.getFormSignature();
        const data = response.data;
        setCSRFToken(data);
        if (!data?.token) {
            return null;
        }
        return { [data.tokenName || "apiToken"]: data.token };
    }
}
